import { render, staticRenderFns } from "./LogDetailsViewPage.vue?vue&type=template&id=bf0917d8"
import script from "./LogDetailsViewPage.vue?vue&type=script&lang=js"
export * from "./LogDetailsViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports